import { render, staticRenderFns } from "./OrganizationMedia.vue?vue&type=template&id=b2214150&scoped=true"
import script from "./OrganizationMedia.vue?vue&type=script&lang=ts&setup=true"
export * from "./OrganizationMedia.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./OrganizationMedia.vue?vue&type=style&index=0&id=b2214150&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2214150",
  null
  
)

export default component.exports